import React, { useEffect, useState } from 'react'
import Svg from '../../../../../../../component/common/Svg'
import style from "../../../../../../style.module.css"
import Card from "../../../../../../../core/Card"
import { useTranslation } from 'react-i18next';


const QuestionDropdown = ({ options, handleChange, value, index: GlobalIndex, currentOption, setCurrentOption, setTmpOption, tmpOption }) => {
    const { t, i18n } = useTranslation();

    //Functionalities
    const handleClick = (option) => {
        if (!currentOption) {
            setCurrentOption(option)
            handleChange(option)

        }
        setTmpOption(option)
    }

    const handleChangeOption = () => {
        handleChange(tmpOption)
        setCurrentOption(tmpOption)
    }

    //Effect
    useEffect(() => {
        if (value) {
            setCurrentOption(options?.filter((option) => option.value === value)[0])
        }
    }, [options, value])

    return (
        <>
            <div className="dropdown table-dropdown ques-options">
                <button
                    className="btn dropdown-tgl"
                    type="button"
                    id={"quesoptions" + GlobalIndex}
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                >
                    <Svg name={currentOption?.svg} /> {currentOption?.name ?? 'Select'}
                </button>
                <div className="dropdown-menu" aria-labelledby={"quesoptions" + GlobalIndex}>
                    {
                        options?.map((option, index) => {
                            return (
                                <span
                                    key={index}
                                    onClick={() => handleClick(option)}
                                    data-bs-toggle={!currentOption ? "" : "modal"}
                                    data-bs-target={!currentOption ? '' : `#changeField${GlobalIndex}`}
                                    className="dropdown-item d-flex align-items-center"
                                >
                                    <div className="icon-circle me-3">
                                        <Svg name={option.svg} />
                                    </div>
                                    <span className="dropdown-item">{option.name}</span>
                                </span>
                            )
                        })
                    }
                </div>
            </div >

            <div className="customvar-modal modal custom-modal fade deleteModal" id={`changeField${GlobalIndex}`} tabIndex={-1} aria-labelledby="changeModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className={"formcontainer" + " " + style.container}>
                                <div className={"formvawrapper delete-modal-wrap modal-sm" + " " + style.wrapper}>
                                    <Card view="raised" className={"formstyle p-0" + " " + style.card} >
                                        <div className="delete-header d-flex align-items-center">
                                            <div className="icon">
                                                <Svg name="exclamation" />
                                            </div>
                                            <div className="media-body ps-3">
                                                <h4 className='mb-0'>{t('survey.change_question_heading')}</h4>
                                            </div>
                                        </div>
                                        <div className="delete-body-wrap">
                                            <div className="change-field-wrap p-0 mb-4">
                                                <div className="subtitle text-center">{t('survey.change_question_warning')}</div>
                                            </div>
                                            <div className="button-wrap d-flex justify-content-center mb-0">
                                                <button type="button" className="btn btn-bordered color-cancel" data-bs-dismiss="modal" >{t('survey.customVariable.cancel')}</button>
                                                <button type="button" className="btn btn-delete ms-3" data-bs-dismiss="modal" onClick={handleChangeOption}>{t('survey.change_type')}</button>
                                            </div>
                                        </div>
                                    </Card>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default QuestionDropdown